import React from "react";

const UserSearchBar = ({ searchQuery, setSearchQuery }) => {
  return (
    <input
      type="text"
      placeholder="🔍 Search users by name, email, or username"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="mt-2 sm:mt-0 sm:ml-4 w-full sm:w-80 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
    />
  );
};

export default UserSearchBar;
